module.exports = __webpack_public_path__ + "img/danilo.c0b47357.jpg";